<template>
    <div>
        <img
            :src="`https://firebasestorage.googleapis.com/v0/b/psg-11d1b.appspot.com/o/emojis%2F${responseEmoji.name}_144.png?alt=media`"
            :alt="responseEmoji.name"
            :width="size"
            :height="size"
        >
        <span v-if="hasText" class="text-16 align-middle"> {{ responseEmoji.text | capitalize}}</span>
    </div>

</template>

<script>
export default {
    name: 'ResponseEmoji',
    data: () => {
        return {
            emojis: {
                3: {
                    name: 'happy-1',
                    text: 'incrível',
                },
                2: {
                    name: 'happy',
                    text: 'feliz',
                },
                1: {
                    name: 'confused',
                    text: 'regular',
                },
                0: {
                    name: 'sad',
                    text: 'infeliz',
                },
            },
        }
    },
    props: {
        includeNeutral: {
            type: Boolean,
            default: false,
        },
        response: {
            type: Number,
            default: 0,
        },
        size: {
            type: String,
            default: '50px',
        },
        hasText: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        responseEmoji () {
            return this.emojis[this.response]
        },
    },
    filters: {
        capitalize: value => {
            if (!value) return ''

            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
    },
}
</script>
